import React, { useState } from 'react';
import { Mail, CheckCircle, Lock } from 'lucide-react';
import { useAuth } from '../../../contexts/AuthContext';
import { Button } from '../../ui/Button';
import { Card } from '../../ui/Card';

export const PasswordResetCard: React.FC = () => {
  const [success, setSuccess] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { user, requestPasswordReset } = useAuth();

  const handlePasswordReset = async () => {
    if (!user?.email || isSubmitting) return;
    setSuccess('');
    setIsSubmitting(true);

    try {
      await requestPasswordReset(user.email);
      setSuccess('Password reset email sent! Check your inbox.');
      setTimeout(() => setSuccess(''), 10000);
    } catch {
      setSuccess('Password reset email sent! Check your inbox.');
      setTimeout(() => setSuccess(''), 10000);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Card padding="md" className="bg-neutral-50 border border-neutral-200">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0 flex-1">
          <div className="w-9 h-9 rounded-lg flex-shrink-0 flex items-center justify-center bg-neutral-200">
            <Lock className="w-4 h-4 text-neutral-600" />
          </div>
          <div className="min-w-0">
            <p className="text-[13px] font-medium text-neutral-900">Password</p>
            <p className="text-[11px] text-neutral-500">Secure your account with a strong password</p>
          </div>
        </div>
        <Button
          variant="primary"
          size="sm"
          onClick={handlePasswordReset}
          disabled={isSubmitting}
          loading={isSubmitting}
          leftIcon={!isSubmitting ? <Mail className="w-3 h-3" /> : undefined}
        >
          Reset
        </Button>
      </div>

      {success && (
        <div className="mt-3 flex items-center gap-2 p-2 rounded-lg bg-success-50 border border-success-200">
          <CheckCircle className="w-3.5 h-3.5 flex-shrink-0 text-success-600" />
          <p className="text-[11px] text-success-700">{success}</p>
        </div>
      )}
    </Card>
  );
};
